import { Link } from "react-router-dom";
import {
  MailIcon,
  ClockIcon,
} from "../components/icons/Social-media";
import { useAboutData, useSocialMediaData } from '../context/companyDataContext';
import { useEffect } from "react";
import { StaticIcons } from "../components/icons/static-icons.js";
import { FacebookIcon, InstagramIcon, LinkedinIcon, SkypeIcon, WhatsappIcon, WechatIcon, TwitterIcon } from "../components/icons/Social-media";
export default function NarrowHeader() {
  const aboutData = useAboutData();
  const socialMediaData = useSocialMediaData();
  const email = aboutData?.emails.primary;
  const socialLinks: any = [
    {
      id: 1,
      icon: StaticIcons.Facebook,
      name: "Facebook",
      link: "https://www.facebook.com",
      created_at: "2024-11-25T11:40:26.000000Z",
      updated_at: "2024-12-02T12:02:59.000000Z",
      status: false
    },
    {
      id: 2,
      icon: StaticIcons.Intsa,
      name: "Instagram",
      link: "https://www.instagram.com",
      created_at: "2024-11-25T11:40:26.000000Z",
      updated_at: "2024-12-02T12:02:59.000000Z",
      status: false
    },
    {
      id: 3,
      icon: StaticIcons.Linkedin,
      name: "LinkednIn",
      link: "https://linkedin.com",
      created_at: "2024-11-25T11:40:26.000000Z",
      updated_at: "2024-12-02T12:02:59.000000Z",
      status: false
    },
    {
      id: 4,
      icon: StaticIcons.X,
      name: "X",
      link: "https://x.com",
      created_at: "2024-12-02T12:04:12.000000Z",
      updated_at: "2024-12-02T12:17:33.000000Z",
      status: false
    },
    {
      id: 5,
      icon: StaticIcons.WeChat,
      name: "Skype",
      link: "https://skype.com",
      created_at: "2024-12-02T12:04:12.000000Z",
      updated_at: "2024-12-02T12:17:33.000000Z",
      status: false
    },
    {
      id: 6,
      icon: StaticIcons.Whatsapp,
      name: "Whatsapp",
      link: "https://whatsapp.com",
      created_at: "2024-12-02T12:04:12.000000Z",
      updated_at: "2024-12-02T12:17:33.000000Z",
      status: false
    },
  ];

  return (
    <div className="hidden py-2 md:py-0 bg-primary-red h-auto md:h-10 w-full lg:flex flex-col md:flex-row justify-center md:justify-around items-center">
      <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4">
        <p className="flex flex-row justify-center items-center gap-2">
          <span>
            <MailIcon FillColor={"#FFFFFF"} />
          </span>
          <span className="font-dmSans font-medium text-white text-md">
            {email}
          </span>
        </p>
        <div className="hidden md:block  h-6 bg-divider w-[2px]" />
        <p className="flex flex-row justify-center items-center gap-2">
          <span>
            <ClockIcon FillColor={"#FFFFFF"} />
          </span>
          <span className="font-dmSans font-medium text-white text-md">
            Working: 9.00am - 5.00pm
          </span>
        </p>
      </div>
      <div className="flex flex-row justify-center items-center gap-4 mt-2 md:mt-0">
        <div className="hidden md:block h-6 bg-divider w-[2px]" />
        {socialLinks?.map((item: any) => (
          <Link key={item.id} to={item.link}>
            <img width={item.id > 4 ? "18" : ""} height={item.id > 4 ? "10" : ""} src={item.icon} alt={item.name} />
          </Link>
        ))}
      </div>
    </div>
  );
}
